import {
  getForm as publicGetForm,
  addControl as publicAddControl,
  updateControl as publicUpdateControl,
  deleteControl as publicDeleteControl,
  updateMessages as publicUpdateMessages,
  publishDraft as publicPublishDraft,
  discardDraft as publicDiscardDraft,
} from './events-v1-form-forms.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onFormEventUpdated as publicOnFormEventUpdated } from './events-v1-form-forms.public.js';

export const getForm: MaybeContext<
  BuildRESTFunction<typeof publicGetForm> & typeof publicGetForm
> = /*#__PURE__*/ createRESTModule(publicGetForm);
export const addControl: MaybeContext<
  BuildRESTFunction<typeof publicAddControl> & typeof publicAddControl
> = /*#__PURE__*/ createRESTModule(publicAddControl);
export const updateControl: MaybeContext<
  BuildRESTFunction<typeof publicUpdateControl> & typeof publicUpdateControl
> = /*#__PURE__*/ createRESTModule(publicUpdateControl);
export const deleteControl: MaybeContext<
  BuildRESTFunction<typeof publicDeleteControl> & typeof publicDeleteControl
> = /*#__PURE__*/ createRESTModule(publicDeleteControl);
export const updateMessages: MaybeContext<
  BuildRESTFunction<typeof publicUpdateMessages> & typeof publicUpdateMessages
> = /*#__PURE__*/ createRESTModule(publicUpdateMessages);
export const publishDraft: MaybeContext<
  BuildRESTFunction<typeof publicPublishDraft> & typeof publicPublishDraft
> = /*#__PURE__*/ createRESTModule(publicPublishDraft);
export const discardDraft: MaybeContext<
  BuildRESTFunction<typeof publicDiscardDraft> & typeof publicDiscardDraft
> = /*#__PURE__*/ createRESTModule(publicDiscardDraft);
/**
 * Triggered when a form is updated or published.
 */
export const onFormEventUpdated: BuildEventDefinition<
  typeof publicOnFormEventUpdated
> &
  typeof publicOnFormEventUpdated = createEventModule(publicOnFormEventUpdated);

export {
  InputControlType,
  ValueType,
  RequestedFields,
  LocationType,
  SubdivisionType,
  Status,
  EventStatus,
  EventType,
  RegistrationStatus,
  RsvpStatusOptions,
  TaxType,
  CheckoutType,
  VisitorType,
  ConferenceType,
  State,
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  Origin,
  LayoutDataBackgroundType,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  Type,
  WebhookIdentityType,
} from './events-v1-form-forms.universal.js';
export {
  Form,
  InputControl,
  Input,
  OptionSelection,
  OptionSelectionSelectedOptionOneOf,
  Label,
  FormMessages,
  RsvpFormMessages,
  PositiveResponseConfirmation,
  NegativeResponseConfirmation,
  Positive,
  Negative,
  CheckoutFormMessages,
  ResponseConfirmation,
  RegistrationClosedMessages,
  TicketsUnavailableMessages,
  FormInputControlAdded,
  FormInputControlUpdated,
  FormInputControlDeleted,
  GetFormRequest,
  GetFormResponse,
  AddControlRequest,
  AddControlRequestControlOneOf,
  PhoneControl,
  AddressControl,
  AddressControlLabels,
  DateControl,
  AdditionalGuestsControl,
  Labels,
  DropdownControl,
  RadioButtonControl,
  CheckboxControl,
  TextControl,
  AddControlResponse,
  UpdateControlRequest,
  UpdateControlRequestControlOneOf,
  NameControl,
  NameControlLabels,
  EmailControl,
  UpdateControlResponse,
  DeleteControlRequest,
  DeleteControlResponse,
  UpdateMessagesRequest,
  UpdateMessagesResponse,
  PublishDraftRequest,
  PublishDraftResponse,
  EventUpdated,
  Location,
  MapCoordinates,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  ScheduleConfig,
  Recurrences,
  Occurrence,
  Event,
  Scheduling,
  Registration,
  RsvpCollection,
  RsvpCollectionConfig,
  RsvpConfirmationMessages,
  RsvpConfirmationMessagesPositiveResponseConfirmation,
  RsvpConfirmationMessagesNegativeResponseConfirmation,
  Ticketing,
  TicketingConfig,
  TaxConfig,
  TicketsConfirmationMessages,
  Money,
  ExternalEvent,
  CalendarLinks,
  SiteUrl,
  Dashboard,
  RsvpSummary,
  TicketingSummary,
  GuestListConfig,
  Feed,
  OnlineConferencing,
  OnlineConferencingConfig,
  OnlineConferencingSession,
  SeoSettings,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  Agenda,
  Category,
  CategoryCounts,
  EventDisplaySettings,
  LabellingSettings,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackgroundImage,
  Banner,
  LayoutDataBackground,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  Badge,
  DiscardDraftRequest,
  DiscardDraftResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  FormEventUpdatedEnvelope,
  AddControlOptions,
  AddControlOptionsControlOneOf,
  UpdateControlIdentifiers,
  UpdateControlIdentifiersControlOneOf,
  UpdateControlOptions,
  UpdateControlOptionsControlOneOf,
  DeleteControlIdentifiers,
  UpdateMessagesOptions,
} from './events-v1-form-forms.universal.js';
export {
  InputControlTypeWithLiterals,
  ValueTypeWithLiterals,
  RequestedFieldsWithLiterals,
  LocationTypeWithLiterals,
  SubdivisionTypeWithLiterals,
  StatusWithLiterals,
  EventStatusWithLiterals,
  EventTypeWithLiterals,
  RegistrationStatusWithLiterals,
  RsvpStatusOptionsWithLiterals,
  TaxTypeWithLiterals,
  CheckoutTypeWithLiterals,
  VisitorTypeWithLiterals,
  ConferenceTypeWithLiterals,
  StateWithLiterals,
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  CardStylesTypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  OriginWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  TypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  AddControlApplicationErrors,
  UpdateControlApplicationErrors,
  DeleteControlApplicationErrors,
} from './events-v1-form-forms.universal.js';
